import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import GlobalStats from '../common/GlobalStats';

import {
  trackRecommendation,
} from '../../../util/trackingHelper';
import featureFlag from '../../../util/featureFlags';

const isSpreadsheetUploadTracking = featureFlag.get('isSpreadsheetUploadTracking');

class DirectoryNavV2 extends React.Component {
  constructor(props) {
    super(props);
    this.afterExport = this.afterExport.bind(this);
  }

  afterExport = () => {
    const { onConfirmAction } = this.props;
    this.exportDropdown.hide();
    onConfirmAction('Guest List Exported');
  };

  render() {
    const {
      formattedGlobalStats,
      formattedGuestAgeStats,
      numGuestsAttending,
      onAddGuestGroup,
      onUploadSpreadsheet
    } = this.props;

    return (
      <div className="row">
        <div className="col-xs-12 navbar-default">
          <h1 className="page-heading col-xs-12 col-sm-6">All Guests</h1>
          <div className="nav navbar-nav navbar-right navbar__add-guests">
            <ul className="list-inline">
              <li className="open-add-guest-modal list-inline">
                <div>
                  <ButtonV2
                    variant="secondary"
                    id="GL-step2"
                    onClick={() => {
                      onAddGuestGroup();
                      if (isSpreadsheetUploadTracking) {
                        trackRecommendation('Clicked', {
                          recommendation_key: 'add_guests_manually',
                          recommendation_name: 'Add Guests Manually',
                          recommendation_copy: 'Add Guests',
                        });
                      }
                    }}
                  >
                    Add Guests
                  </ButtonV2>
                </div>
              </li>
              <li className="upload-spreadsheet">
                <div>
                  <ButtonV2
                    variant="secondary"
                    id="GL-step1"
                    onClick={() => {
                      onUploadSpreadsheet();
                      if (isSpreadsheetUploadTracking) {
                        trackRecommendation('Clicked', {
                          recommendation_key: 'upload_guest_spreadsheet',
                          recommendation_name: 'Upload Guest Spreadsheet',
                          recommendation_copy: 'Upload Spreadsheet',
                        });
                      }
                    }}
                  >
                    Upload Spreadsheet
                  </ButtonV2>
                </div>
              </li>
            </ul>
          </div>
        </div>
        {numGuestsAttending > 0 && (
          <div>
            <div className="global-stats-container">
              <ul className="nav navbar-nav navbar-left" style={{ paddingLeft: '14px' }}>
                <li className="first-set"><GlobalStats stats={formattedGlobalStats} /></li>
                <li className="second-set"><GlobalStats stats={formattedGuestAgeStats} /></li>
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}

DirectoryNavV2.propTypes = {
  formattedGlobalStats: PropTypes.arrayOf(PropTypes.shape({})),
  formattedGuestAgeStats: PropTypes.arrayOf(PropTypes.shape({})),
  onAddGuestGroup: PropTypes.func,
  onUploadSpreadsheet: PropTypes.func,
  numGuestsAttending: PropTypes.number,
  onConfirmAction: PropTypes.func,
};

export default DirectoryNavV2;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/DirectoryNavV2.jsx